import { createAction, props } from '@ngrx/store';
import { Feature } from '../models/feature.model';

export const loadFeatures = createAction('[Features] Load Features');

export const loadFeaturesSuccess = createAction(
  '[Features] Load Features Success',
  props<{ features: Feature[] }>()
);

export const loadFeaturesFailure = createAction(
  '[Features] Load Features Failure',
  props<{ error: string }>()
);

export const loadAccountFeatureScope = createAction(
  '[Features] Load Account Feature Scope'
);

export const loadAccountFeatureScopeSuccess = createAction(
  '[Features] Load Account Feature Scope Success',
  props<{ featureCodes: string[] }>()
);

export const loadAccountFeatureScopeFailure = createAction(
  '[Features] Load Account Feature Scope Failure',
  props<{ error: string }>()
);

export const resetFeatures = createAction('[Features] Reset Features');
